<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="6" class="pb-0">
        <AutocompleteGrade
          dense
          outlined
          return-object
          label="Học phần"
          v-model="grade"
          @change="gradeChanged"
          required
          :rules="[$rules.required]"
          class="required"
        />
      </v-col>
      <v-col cols="6" class="pb-0">
        <AutocompleteClass
          v-model="classData"
          label="Lớp"
          outlined
          dense
          :filter="classFilter"
          required
          @change="classChanged"
          class="required"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col v-if="showTeacher === true && classData" cols="6" class="pt-0">
        <AutocompleteTeacherCard
          :multiple="true"
          v-model="teachers"
          clear-icon="mdi-close"
          label="Giáo viên chính"
          outlined
          dense
          deletable-chips
          required
          class="required"
          :rules="[$rules.required]"
          :filter="teacherFilter"
        />
      </v-col>
      <v-col v-if="showAssistant === true && classData" cols="6" class="pt-0">
        <AutocompleteTeacherCard
          :multiple="true"
          v-model="assistants"
          clear-icon="mdi-close"
          label="Trợ giảng"
          outlined
          dense
          deletable-chips
          required
          :filter="teacherFilter"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import get from 'lodash-es/get'
import { mapActions } from 'vuex'

export default {
  components: {
    AutocompleteSubject,
    AutocompleteGrade,
    AutocompleteClass,
    AutocompleteTeacherCard,
  },
  props: {
    state: Boolean,
    showTeacher: Boolean,
    showAssistant: Boolean,
  },
  data() {
    return {
      grade: null,
      classData: null,
      assistants: [],
      teachers: [],
      subject: null,
      teachings: null,
    }
  },
  computed: {
    classFilter() {
      return { grade: get(this.grade, 'id'), type: 'coreCurriculum', division_null: false }
    },
    subjectFilter() {
      return {
        grade: get(this.grade, 'id') || get(this.classData, 'grade.id'),
        division: get(this.classData, 'division.id'),
        type: 'coreCurriculum',
      }
    },
    teacherFilter() {
      return this.classData ? { academicLevels: get(this.classData, 'academicLevel') } : {}
    },
  },
  methods: {
    classChanged(classData) {
      if (
        this.subject &&
        classData &&
        (classData.grade.id !== this.subject.grade.id ||
          get(classData, 'division.id') !== get(this.subject, 'division.id'))
      ) {
        this.subject = null
      }
      this.grade = get(classData, 'grade')
      this.teachers = []
      this.assistants = []
    },
    gradeChanged(grade) {
      if (this.classData && grade && this.classData.grade !== grade) {
        this.classData = null
      }
      if (this.subject && grade && this.subject.subjectGroup.grade !== grade) {
        this.subject = null
      }
      this.grade = grade
    },
    ...mapActions('teaching', ['fetchTeachings']),
    getData() {
      if (this.$refs.form.validate()) {
        return {
          class: this.classData,
          grade: this.grade,
          teachers: this.teachers,
          assistants: this.assistants,
        }
      }
      return null
    },
    resetData() {
      this.grade = null
      this.classData = null
      this.teachers = []
      this.assistants = []
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
  mounted() {
    this.$refs.form.reset()
  },
  async created() {
    this.teachings = await this.fetchTeachings()
  },
  watch: {
    async state(state) {
      if (!state) {
        this.resetData()
        this.$refs.form.reset()
      } else {
        this.teachings = await this.fetchTeachings()
      }
    },
    classData: 'resetValidation',
    grade: 'resetValidation',
    subject: 'resetValidation',
  },
}
</script>
